import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chat',
  initialState: { messages: [] },
  reducers: {
    addMessage: (state, action) => { state.messages.push(action.payload); }
  }
});

// ✅ Properly defined middleware
export const saveStateMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  // Save chat state to localStorage after each action
  localStorage.setItem('chat', JSON.stringify(store.getState().chat));
  return result;
};

export const { addMessage } = chatSlice.actions;
export default chatSlice.reducer;